var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 19,
    viewBox: "0 0 22 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.4619 0C20.601 0 21.5244 0.92341 21.5244 2.0625V16.5623C21.5244 17.7013 20.6009 18.6248 19.4619 18.6248H2.0625C0.92343 18.6248 2.55168e-05 17.7013 0 16.5623V2.0625C0 0.923409 0.923413 0 2.0625 0H19.4619ZM1.22461 9.92505V16.5623C1.22463 17.0247 1.59997 17.3994 2.0625 17.3994H10.1499V9.92505H1.22461ZM11.3745 9.92505V17.3994H19.4619C19.9244 17.3994 20.2998 17.0247 20.2998 16.5623V9.92505H11.3745ZM2.0625 1.22461C1.59996 1.22461 1.22461 1.59996 1.22461 2.0625V8.69971H10.1499V1.22461H2.0625ZM11.3745 1.22461V8.69971H20.2998V2.0625C20.2998 1.59996 19.9244 1.22461 19.4619 1.22461H11.3745Z",
    fill: "#383733"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTile);
export default __webpack_public_path__ + "static/media/tile.ba3d7a51f03cc5e20ff94a030fb29050.svg";
export { ForwardRef as ReactComponent };